import { HTMLAttributes } from 'react'
import clsx from 'clsx'

import { RadioGroup } from 'shared/ui/RadioGroup'
import type { RadioGroupProps } from 'shared/ui/RadioGroup/RadioGroup'

import styles from './styles.module.scss'

export const InputsGroup = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={clsx(styles.inputsGroup, className)} />
)

export const FiltersRadioGroup = ({ className, ...props }: RadioGroupProps) => (
  <RadioGroup {...props} className={clsx(styles.filtersRadioGroup, className)} />
)

export const InputsRow = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={clsx(styles.inputsRow, className)} />
)

export const DesktopClearButton = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={clsx(styles.desktopClearButton, className)} />
)
